module.exports = __webpack_public_path__ + "static/media/logo_edilsystem.e847ff4d.png";